<template>
    <BaseDialog
        :showDialog="showUploadPDFDialog"
        maxDialogWidth="600"
        headline="lang_GENERAL_FILE_IMPORT_DIALOG_TITLE_UPLOAD_FILE"
        :close="closeDialog"
        persistent
        :alvqa="alvqa"
    >
<!-- Dialog Text -->
        <template v-slot:dialogText>
            <v-container fluid>
                <v-row >
                    <v-col 
                        v-html="dialogText"
                        :alvqa="alvqa + '-text'"
                    ></v-col>
                </v-row>

<!-- Progressbars -->
                <v-row v-if="showProgressbar">
                    <v-col>
                        <v-progress-linear 
                            v-model="progressbarValue"
                            height="25"
                            color="dialogProgressbar"
                            :alvqa="alvqa + '-upload-progressbar'"
                        ></v-progress-linear>
                    </v-col>
                </v-row>
            </v-container>
        </template>
<!-- Actions + Validation -->
        <template v-slot:actionsWithValidation>
            <v-card-actions v-if="showUploadActions" class="pt-0 pb-0 pr-6 pl-6">
                <v-container fluid>
                    <v-form v-model="valid">
                        <v-row>
                            <v-col cols="7">
                                <v-file-input
                                    class="pr-6"
                                    v-model="file"
                                    :label="$t('lang_GENERAL_CAPTION_SELECT_FILE')"
                                    :rules="rules"
                                    @change="fileExt = $alvPlugin.extractFileExt(file)"
                                    @click:clear="resetVal()"
                                    show-size
                                    :alvqa="alvqa + '-file-input'"
                                ></v-file-input>
                            </v-col>
                            <v-spacer />
                            <v-col
                                class="text-right" 
                                align-self="center"
                            >
                                <BaseButton 
                                    :disabled="!valid || !file"
                                    @click="submitFile"
                                    label="lang_GENERAL_BUTTON_UPLOAD_FILE"
                                    :alvqa="alvqa+'-button-upload'"
                                />
                            </v-col>
                        </v-row> 
                    </v-form>
                </v-container>
            </v-card-actions>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import api from '@/api_alv'

export default {
    name: "PdfUploadDialog",
    components: {
        BaseDialog,
        BaseButton
    },
    data() {
        return {
            alvqa: 'publishing-sheets-edit-form-panel-pdf-dialog-upload-pdf',
            showProgressbar: false,
            showUploadActions: true,
            progressbarValue: 0,
            file: null,
            fileExt: '',
            valid: false,
            formData: new FormData(),
            rules: [value => !value || (this.fileExt === 'pdf' || this.fileExt === 'zip') || this.$t('lang_GENERAL_DIALOG_TEXT_INVALID_FORMAT') ]
        }
    },
    computed: {
        showUploadPDFDialog: {
            get() { return this.$store.getters.getShowUploadPDFDialog },
            set(show) { this.$store.commit('setShowUploadPDFDialog', show)}
        },
        dialogText: {
            get() { return this.$store.getters.getUploadPDFDialogText },
            set(text) { this.$store.commit('setUploadPDFDialogText', text)}
        }
    },
    methods: { 
        async resetVal() {
            await this.$nextTick()
            this.file = null
        },
        async submitFile() {
            this.dialogText = this.$t('lang_GENERAL_FILE_UPLOAD_DIALOG_TEXT_FILE_IS_BEING_UPLOADED') 
            this.formData.append('file', this.file)  
            this.showUploadActions = false
            this.showProgressbar = true

            // API Call to upload a file
            let sheetAlvId = this.$store.getters.getSheetDetailsAlvId
            let uploadFileResponse = await api.putFile('publishing/sheets' + '/' + sheetAlvId, this.formData, '?type=pdf')

            if(uploadFileResponse.error === -1) {
                this.progressbarValue = 100
                this.$store.dispatch('fetchSheetsPdf')

                this.dialogText = this.$t('lang_GENERAL_FILE_UPLOAD_DIALOG_TEXT_UPLOAD_SUCCESS') 
            } else {
                this.dialogText = this.$alvPlugin.isLangConst(uploadFileResponse.response.errorMsg) ? 
                                    this.$t(uploadFileResponse.response.errorMsg) : uploadFileResponse.response.errorMsg
            }
            this.dialogText += '<br />' + this.$t('lang_GENERAL_DIALOG_TEXT_CLOSE_DIALOG')
        },
        closeDialog() {
            this.showUploadPDFDialog = false
            this.showUploadActions = true
            this.showProgressbar = false
            this.file = null
            this.progressbarValue = 0
            this.dialogText = ''
        }
    }
}
</script>